import React, { useState, memo } from 'react';
import ImageModalComponent from "../ImageModalComponent/ImageModalComponent";

const FeedItem = memo(
  ({
    feed,
    activeReplyId,
    replyInput,
    handleReplyClick,
    handleInputChange,
    handlePostReply,
    setSelectedReply,
    setShowDeleteModal,
  }) => {
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const cleanMsgDetails = feed?.MsgDetails?.replace(/<img[^>]*>/g, "");
    const hasReplies = feed.Reply && Object.values(feed.Reply).length > 0;
    const imgMatches = feed?.MsgDetails?.match(/<img[^>]+src=['"]([^'"]+)['"][^>]*>/g);
    const imageUrls = imgMatches?.map(imgTag => {
      const match = imgTag.match(/src=['"]([^'"]+)['"]/);
      return match?.[1];
    }) || [];

    const handleImageClick = (imageUrl) => {
      if (imageUrl) {
        setSelectedImage(imageUrl);
        setIsImageModalOpen(true);
      }
    };

    const closeImageModal = () => {
      setIsImageModalOpen(false);
      setSelectedImage("");
    };

    return (
      <div key={feed.ID} className="mb-2">
        {/* Forum Card */}
        <div className="forum_card">
          <div className="forum_card_details p-1">
            <div
              className="forum_card_details-container"
              onClick={() => handleImageClick(feed.ProfileImage)}
              style={{ cursor: feed.ProfileImage ? "pointer" : "default" }}
            >
              <img src={feed.ProfileImage || ""} alt="Avatar" />
            </div>
            <h5>{feed.ContactName || ""}</h5>
          </div>

          <div className="forum_card-contain">
            <div className="forum_card-contain-one">
              <h6 className="p-0">
                <b>{feed.Title || ""}</b>{" "}
                <span style={{ color: "#9D9D9D" }}>|</span>{" "}
                <span className="forum-card-date-time">
                  <i className="bi bi-calendar-check"></i>{" "}
                  {new Date(feed.MsgDateTime).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                  })}{" "}
                  |{" "}
                  {new Date(feed.MsgDateTime).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </h6>
              <p
                className="mb-1"
                dangerouslySetInnerHTML={{
                  __html: cleanMsgDetails,
                }}
              ></p>
            </div>
            <div className="forum_card-contain-two">
              {imageUrls.length > 0 &&
                imageUrls.map((imgSrc, index) => (
                  <img
                    key={index}
                    src={imgSrc}
                    alt={`Award ${index + 1}`}
                    className="img-fluid"
                    style={{ marginRight: "8px", cursor: index !== 0 ?"pointer":"cursor" }}
                    onClick={index !== 0 ? () => handleImageClick(imgSrc) : undefined}
                  />
                ))}
            </div>
            <div className="replyIcon">
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center me-2">
                  <i
                    className="bi bi-reply reply-icon"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleReplyClick(feed.ID)}
                  ></i>
                  <span
                    className="reply-label ms-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleReplyClick(feed.ID)}
                  >
                    Reply
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Reply Input Section */}
        <div className="container-fluid p-0">
          <div className="comment-container">
            {activeReplyId === feed.ID && (
              <div className="reply-input-container d-flex align-items-center mt-2">
                <input
                  type="text"
                  placeholder="Write a reply..."
                  value={replyInput[feed.ID] || ""}
                  onChange={(e) => handleInputChange(e, feed.ID)}
                  className="form-control me-2 chat-reply-input"
                />
                <button
                  className="custom-btn-sm me-2"
                  onClick={() => handlePostReply(feed.ID)}
                >
                  Post
                </button>
                <button
                  className="cancel-btn-sm"
                  onClick={() => handleReplyClick(null)}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Reply Section */}
        {hasReplies && (
          <div className="container-fluid p-0 mt-3">
            <div className="reply-comment-container">
              {Object.values(feed.Reply).map((reply) => (
                <div key={reply.ReplyID} className="comment-row">
                  <div
                    className="user-avatar-container"
                    onClick={() => handleImageClick(reply.FilePath)}
                    style={{ cursor: reply.FilePath ? "pointer" : "default" }}
                  >
                    <img
                      src={reply.FilePath || ""}
                      alt="User Avatar"
                      className="user-avatar"
                    />
                  </div>
                  <div className="user-info">
                    <div className="timestamp">
                      {new Date(reply.ReplyMsgDateTime).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "2-digit",
                        }
                      )}{" "}
                      |{" "}
                      {new Date(reply.ReplyMsgDateTime).toLocaleTimeString(
                        "en-US",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        }
                      )}
                    </div>
                    <div className="user-name">
                      {reply.ReplyContactName || ""}
                    </div>
                  </div>
                  <div className="comment-content">{reply.ReplyMsgDetails}</div>
                  {reply.canedit === 1 && (
                    <i
                      className="bi bi-trash ms-2"
                      style={{
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        color: "#2E2E48",
                      }}
                      onClick={() => {
                        setSelectedReply({
                          feedId: feed.ID,
                          replyId: reply.ReplyID,
                        });
                        setShowDeleteModal(true);
                      }}
                      title="Delete comment"
                    ></i>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <ImageModalComponent
          isOpen={isImageModalOpen}
          imageUrl={selectedImage}
          onClose={closeImageModal}
        />
      </div>
    );
  }
);

export default FeedItem;